import { onError } from '@apollo/client/link/error';
import * as Sentry from '@sentry/react';

import { isHandledError } from 'src/shared/graphql';

export const errorLink = onError(({ graphQLErrors, operation }) => {
  if (graphQLErrors) {
    graphQLErrors.forEach(error => {
      const { message: originalMessage, path, locations } = error;

      const message = `GQL error${
        path ? ` @ ${path?.join('/')}` : ''
      } "${originalMessage}"`;

      if (!isHandledError(error)) {
        Sentry.withScope(scope => {
          scope.setExtra('message', message);
          scope.setExtra('path', path);
          scope.setTag('operation', operation.operationName);
          if (locations) {
            scope.setExtra('locations', JSON.stringify(locations));
          }
          const plainError = new Error(error.message);
          plainError.cause = error.cause;
          plainError.name = error.name;
          plainError.stack = error.stack;

          Sentry.captureException(plainError);
        });
      }
    });
  }
});
